/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryValuationResponseDto } from '../../models/inventory-valuation-response-dto';

export interface StockReportsControllerGetInventoryValuation$Params {
}

export function stockReportsControllerGetInventoryValuation(http: HttpClient, rootUrl: string, params?: StockReportsControllerGetInventoryValuation$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryValuationResponseDto>> {
  const rb = new RequestBuilder(rootUrl, stockReportsControllerGetInventoryValuation.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryValuationResponseDto>;
    })
  );
}

stockReportsControllerGetInventoryValuation.PATH = '/stock/reports/inventory-valuation';
